module.exports = __webpack_public_path__ + "img/funnel-entfeed-2021.5cdb7fd3.svg";